import React, { useEffect, useState } from "react";
import { Avatar, Box, Button, Card, CardContent, Checkbox, Container, Divider, FormControl, FormControlLabel, FormGroup, Grid, Grid2, InputLabel, Link, MenuItem, Modal, Select, Stack, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Typography } from "@mui/material";
import Layout from "./Layout";
import CheckCircle from '@mui/icons-material/CheckCircle';
import Paper from '@mui/material/Paper';
import StatusChip from "./StatusChip";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DateField } from "@mui/x-date-pickers";
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';
import FileDownload from '@mui/icons-material/FileDownload';
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { pathOr } from "ramda";
import { leadStatusNum } from "../helpers/status";
import { approveAssignment, raiseFr, rejectAssignment, submitLead, uploadAadhaarDocument, uploadDocument, uploadSelfie } from "../actions/leadsAction";
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import RejectionChip from "./RejectionChip";
import dayjs from "dayjs";

const AddLeads = () => {
  const { id } = useParams();
  const [isEditing, setIsEditing] = useState(false);
  const [checked, setChecked] = useState(false)
  const [reason, setReason] = useState("")
  const [comment, setComment] = useState("")
  const dispatch = useDispatch();
  const { leads } = useSelector(state => state.Leads)
  console.log(leads)
  const [data, setData] = useState({});

  useEffect(() => {
    setIsEditing(true);
  }, [id])

  useEffect(() => {
    const editData = leads.filter((item) => {
      debugger;
      return item._id === id
    })
    setData(pathOr({}, ['0'], editData))
    console.log(pathOr({}, ['0'], editData))
    setPolicy({
      policyNumber: pathOr('', ['0', 'policyNumber'], editData),
      policyHolderName: pathOr('', ['0', 'policyHolderName'], editData),
      policyHolderMobileNumber: pathOr('', ['0', 'policyHolderMobileNumber'], editData),
      fatherName: pathOr('', ['0', 'fatherName'], editData),
      address: pathOr('', ['0', 'policaddressyHolderMobileNumber'], editData),
      city: pathOr('', ['0', 'city'], editData),
      state: pathOr('', ['0', 'state'], editData),
      pincode: pathOr('', ['0', 'pincode'], editData),
      dob: moment(pathOr(new Date(), ['0', 'dob'], editData)).format('MM/DD/YYYY'),
      commencementDate: moment(pathOr(new Date(), ['0', 'commencementDate'], editData)).format('MM/DD/YYYY'),
      planName: pathOr('', ['0', 'planName'], editData),
      term: pathOr('', ['0', 'term'], editData),
      paymentTerm: pathOr('', ['0', 'paymentTerm'], editData),
      sumAssured: pathOr('', ['0', 'sumAssured'], editData),
      premium: pathOr('', ['0', 'premium'], editData),
      paymentFrequency: pathOr('', ['0', 'paymentFrequency'], editData),
      policyStatus: pathOr('', ['0', 'policyStatus'], editData),
      accountNumber: pathOr('', ['0', 'accountNumber'], editData),
      ifsc: pathOr('', ['0', 'ifsc'], editData),
      bank: pathOr('', ['0', 'bank'], editData),
      bonusTillDate: pathOr('', ['0', 'data', 'bonusTillDate'], editData),
      surrenderValue: pathOr('', ['0', 'data', 'surrenderValue'], editData),
      duePayable: pathOr('', ['0', 'data', 'duePayable'], editData),
      paidUpto: moment(pathOr(new Date(), ['0', 'data', 'paidUpto'], editData)).format('MM/DD/YYYY'),
      dueDate: moment(pathOr(new Date(), ['0', 'data', 'dueDate'], editData)).format('MM/DD/YYYY'),
      alternateNumber: pathOr('', ['', 'alternateNumber'], editData),
    })
  }, [leads])


  const [policy, setPolicy] = useState({
    policyNumber: '',
    policyHolderName: '',
    policyHolderMobileNumber: '',
    fatherName: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    dob: new Date(),
    commencementDate: new Date(),
    planName: '',
    term: '',
    paymentTerm: '',
    sumAssured: '',
    premium: '',
    paymentFrequency: '',
    policyStatus: 'Inforce',
    accountNumber: '',
    ifsc: '',
    bank: '',
    bonusTillDate: '',
    surrenderValue: 0,
    duePayable: 0,
    paidUpto: new Date(),
    dueDate: new Date(),
    alternateNumber: ""
  });





  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  const NumericFormatCustom = React.forwardRef(
    function NumericFormatCustom(props, ref) {
      const { onChange, ...other } = props;



      return (
        <NumericFormat
          {...other}
          getInputRef={ref}
          onValueChange={(values) => {
            onChange({
              target: {
                name: props.name,
                value: values.value,
              },
            });
          }}
          thousandSeparator
          valueIsNumericString
          prefix="₹"
        />
      );
    },
  );

  NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };




  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: '#F7FAF5',
    //   border: '2px solid #000',
    boxShadow: 24,
    p: 4

  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      dispatch(submitLead(policy))
    } catch (e) {
      console.log(e.message);
    }
  }

  const [message, setMessage] = useState('');

  const handleInputChange = (event) => {
    const value = event.target.value;

    if (/^\d*$/.test(value)) {

      setPolicy({
        ...policy,
        'policyHolderMobileNumber': value,
      });
      // Regular expression to match exactly 10 digits
      const regex = /^\d{10}$/;
      if (value.length === 0 || regex.test(value)) {
        setMessage('');
      } else {
        setMessage('Mobile number must be exactly 10 digits.');
      }
    } else {
      setMessage('Only digits are allowed.');
    }

  };
  const handleAlternateInputChange = (event) => {
    const value = event.target.value;

    if (/^\d*$/.test(value)) {

      setPolicy({
        ...policy,
        'alternateNumber': value,
      });
      // Regular expression to match exactly 10 digits
      const regex = /^\d{10}$/;
      if (value.length === 0 || regex.test(value)) {
        setMessage('');
      } else {
        setMessage('Mobile number must be exactly 10 digits.');
      }
    } else {
      setMessage('Only digits are allowed.');
    }

  };

  return (
    <>
      <Layout>
        <React.Fragment>
          <Container>
            <Grid2 container alignItems={"center"} justifyContent={'space-between'}>
              <Grid2 item>
                <Typography variant="h4" mt={2} mb={2}>{"Policy Details "}</Typography>
              </Grid2>
            </Grid2>
            <Paper>

              <form onSubmit={handleSubmit}>
                <Box m={1} p={2} sx={{ background: '#F7FAF5' }}>
                  <Typography mb={3}>{"Policy Details"}</Typography>


                  <Grid2 columns={{ xs: 4, sm: 8, md: 12 }} container spacing={3} >
                    <Grid2 item size={4}>
                      <TextField required onChange={(e) => {
                        setPolicy({
                          ...policy,
                          'policyNumber': e.target.value,
                        });
                      }} fullWidth id="txtPolicyNumber" value={policy.policyNumber} label="Policy Number" variant="outlined" />
                    </Grid2>
                    <Grid2 item size={4}>
                      <FormControl fullWidth>
                        <TextField required onChange={(e) => {
                          setPolicy({
                            ...policy,
                            'planName': e.target.value,
                          });
                        }} fullWidth id="txtPlanName" value={policy.planName} label="Plan Name" variant="outlined" />
                      </FormControl>
                    </Grid2>
                    <Grid2 item size={4}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateField']}>
                          <DateField onChange={(e) => {
                            setPolicy({
                              ...policy,
                              'commencementDate': e,
                            });
                          }} fullWidth label="Commencement Date" value={dayjs(policy.commencementDate)}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Grid2>
                    <Grid2 item size={4}>
                      <TextField required type="number" onChange={(e) => {
                        setPolicy({
                          ...policy,
                          'term': e.target.value,
                        });
                      }} value={policy.term} fullWidth id="txtPolicyTerm" label="Policy Term" variant="outlined" />
                    </Grid2>
                    <Grid2 item size={4}>
                      <TextField required type="number" onChange={(e) => {
                        setPolicy({
                          ...policy,
                          'paymentTerm': e.target.value,
                        });
                      }} value={policy.paymentTerm} fullWidth id="txtPremiumTerm" label="Premium Term" variant="outlined" />
                    </Grid2>
                    <Grid2 item size={4}>
                      <TextField required type="number" onChange={(e) => {
                        setPolicy({
                          ...policy,
                          'premium': e.target.value,
                        });
                      }} value={policy.premium} fullWidth id="txtPremium" label="Premium" variant="outlined" />
                    </Grid2>
                    <Grid2 item size={4}>
                      <TextField required type="number" onChange={(e) => {
                        setPolicy({
                          ...policy,
                          'sumAssured': e.target.value,
                        });
                      }} value={policy.sumAssured} fullWidth id="txtSumAssured" label="Sum Assured" variant="outlined" />
                    </Grid2>
                    <Grid2 item size={4}>
                      <TextField required onChange={(e) => {
                        setPolicy({
                          ...policy,
                          'bonusTillDate': e.target.value,
                        });
                      }} type="number" fullWidth id="txtBonusAmount" label="Bonus Amount" variant="outlined" />
                    </Grid2>
                    <Grid2 item size={4}>
                      <TextField required type="number"
                        onChange={(e) => {
                          setPolicy({
                            ...policy,
                            'surrenderValue': e.target.value,
                          });
                        }}
                        fullWidth id="txtSurrenderValue" label="Surrender Value" variant="outlined"
                      // slotProps={{
                      //   input: {
                      //     inputComponent: NumericFormatCustom,
                      //   },
                      // }}
                      />
                    </Grid2>
                    <Grid2 item size={4}>
                      <TextField required type="number" onChange={(e) => {
                        setPolicy({
                          ...policy,
                          'duePayable': e.target.value,
                        });
                      }} fullWidth id="txtDuePayable" label="Due Payable" variant="outlined"
                      // slotProps={{
                      //   input: {
                      //     inputComponent: NumericFormatCustom,
                      //   },
                      // }}
                      />
                    </Grid2>
                    <Grid2 item size={4}>
                      <FormControl fullWidth>
                        <InputLabel disabled id="lblPolicyStatus">Policy Status</InputLabel>
                        <Select
                          labelId="lblStatus"
                          id="ddlStatus"
                          label="Policy Status"
                          fullWidth
                          value={policy.policyStatus}
                          onChange={(e) => {
                            setPolicy({
                              ...policy,
                              'policyStatus': e.target.value,
                            });
                          }}
                        >
                          <MenuItem value={"Inforce"}>{"Inforce"}</MenuItem>
                          <MenuItem value={"Paidup"}>{"Paidup"}</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid2>
                    <Grid2 item size={4}>
                      <FormControl fullWidth>
                        <InputLabel disabled id="lblPaymentFrequency">Payment Frequency</InputLabel>
                        <Select
                          labelId="lblFrequency"
                          id="ddlFrequency"
                          value={policy.paymentFrequency}
                          label="Payment Frequency"
                          fullWidth
                          onChange={(e) => {
                            setPolicy({
                              ...policy,
                              'paymentFrequency': e.target.value,
                            });
                          }}
                        >
                          <MenuItem value={'Yearly'}>{'Yearly'}</MenuItem>
                          <MenuItem value={'Half Yrly'}>{'Half Yearly'}</MenuItem>
                          <MenuItem value={'Quaterly'}>{'Quaterly'}</MenuItem>
                          <MenuItem value={'Monthly'}>{'Monthly'}</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid2>
                    <Grid2 item size={4}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateField']}>
                          <DateField
                            onChange={(e) => {
                              setPolicy({
                                ...policy,
                                'paidUpto': e,
                              });
                            }}
                            value={dayjs(policy.paidUpto)} fullWidth label="Paid Upto" />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Grid2>
                    <Grid2 item size={4}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateField']}>
                          <DateField 
                          onChange={(e) => {
                            setPolicy({
                              ...policy,
                              'dueDate': e,
                            });
                          }}
                          value={dayjs(policy.dueDate)} fullWidth label="Due Date" />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Grid2>
                  </Grid2>


                </Box>

                <Box m={1} mt={4} p={2} sx={{ background: '#F7FAF5' }}>
                  <Typography mb={3}>{"Customer Details"}</Typography>
                  <FormControl sx={{ width: '100%' }}>
                    <Grid2 columns={{ xs: 4, sm: 8, md: 12 }} container spacing={3} >
                      <Grid2 item size={4}>
                        <TextField required onChange={(e) => {
                          setPolicy({
                            ...policy,
                            'policyHolderName': e.target.value,
                          });
                        }} value={policy.policyHolderName} fullWidth id="txtFirstName" label="Name" variant="outlined" />
                      </Grid2>
                      <Grid2 item size={4}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={['DateField']}>
                            <DateField 
                            onChange={(e) => {
                              setPolicy({
                                ...policy,
                                'dob': e,
                              });
                            }}
                            value={dayjs(policy.dob)} fullWidth label="Date Of Birth" />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Grid2>
                      <Grid2 item size={4}>
                        <TextField required onChange={(e) => {
                          handleInputChange(e)
                        }} fullWidth value={policy.policyHolderMobileNumber} id="txtMobile" label="Mobile Number" variant="outlined" />
                        {message && (
                          <p style={{ color: message === 'Mobile number is valid.' ? 'green' : 'red' }}>
                            {message}
                          </p>
                        )}
                      </Grid2>
                      <Grid2 item size={4}>
                        <TextField onChange={(e) => {
                          handleAlternateInputChange(e)
                        }} fullWidth value={policy.alternateNumber} id="txtAltMobile" label="Alternate Mobile Number" variant="outlined" />
                        {message && (
                          <p style={{ color: message === 'Mobile number is valid.' ? 'green' : 'red' }}>
                            {message}
                          </p>
                        )}
                      </Grid2>
                      <Grid2 item size={4}>
                        <TextField onChange={(e) => {
                          setPolicy({
                            ...policy,
                            'email': e.target.value,
                          });
                        }} fullWidth id="txtEmail" label="Email" variant="outlined"
                          inputProps={{
                            type: "email",
                          }}
                        />
                      </Grid2>
                      <Grid2 item size={4}>
                        <TextField onChange={(e) => {
                          setPolicy({
                            ...policy,
                            'fatherName': e.target.value,
                          });
                        }} fullWidth id="txtFatherName" label="Father Name" variant="outlined"
                        />
                      </Grid2>
                      <Grid2 item size={12}>
                        <TextField onChange={(e) => {
                          setPolicy({
                            ...policy,
                            'address': e.target.value,
                          });
                        }} fullWidth id="txtAddress" label="Address" variant="outlined" />
                      </Grid2>
                      <Grid2 item size={4}>
                        <TextField onChange={(e) => {
                          setPolicy({
                            ...policy,
                            'city': e.target.value,
                          });
                        }} fullWidth id="txtCity" label="City" variant="outlined" />
                      </Grid2>
                      <Grid2 item size={4}>
                        <TextField onChange={(e) => {
                          setPolicy({
                            ...policy,
                            'state': e.target.value,
                          });
                        }} fullWidth id="txtState" label="State" variant="outlined" />
                      </Grid2>
                      <Grid2 item size={4}>
                        <TextField onChange={(e) => {
                          setPolicy({
                            ...policy,
                            'pincode': e.target.value,
                          });
                        }} fullWidth id="txtPincode" label="Pincode" variant="outlined" />
                      </Grid2>
                    </Grid2>
                  </FormControl>
                </Box>

                <Box m={1} mt={4} p={2} sx={{ background: '#F7FAF5' }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
                    <Typography >{"Bank Details"}</Typography>
                    {/* <CheckCircle sx={{ color: '#66DA45' }} /> */}
                  </div>

                  <FormControl sx={{ width: '100%' }}>
                    <Grid2 columns={{ xs: 4, sm: 8, md: 12 }} container spacing={3} >
                      <Grid2 item size={4}>
                        <TextField onChange={(e) => {
                          setPolicy({
                            ...policy,
                            'accountNumber': e.target.value,
                          });
                        }} value={pathOr("", ["accountNumber"], policy)} fullWidth id="txtAccountNumber" label="Account Number" variant="outlined" />
                      </Grid2>
                      <Grid2 item size={4}>
                        <TextField onChange={(e) => {
                          setPolicy({
                            ...policy,
                            'ifsc': e.target.value,
                          });
                        }} value={pathOr("", ["ifsc"], policy)} fullWidth id="txtIFSC" label="IFSC Code" variant="outlined" />
                      </Grid2>
                      <Grid2 item size={4}>
                        <TextField onChange={(e) => {
                          setPolicy({
                            ...policy,
                            'bank': e.target.value,
                          });
                        }} value={pathOr("", ["bank"], policy)} fullWidth id="txtBankName" label="Bank Name" variant="outlined" />
                      </Grid2>
                    </Grid2>
                  </FormControl>

                </Box>

                <Box>
                  <button type="submit">SUBMIT</button>
                  {/* <Button
                              component="label"
                           type="submit"
                              variant="contained"
                    tabIndex={-1}
                    onClick={()=>{saveForm()}}
                            >
                             SUBMIT

                            </Button> */}
                </Box>
              </form>


            </Paper>









          </Container>
        </React.Fragment>
      </Layout >
    </>
  )
}

export default AddLeads